module.exports = __webpack_public_path__ + "static/img/20250320005.5901c00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320005.jpg
// module id = 46xC
// module chunks = 0